import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fe55dc24&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=fe55dc24&scoped=scoped&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&id=fe55dc24&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe55dc24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe55dc24')) {
      api.createRecord('fe55dc24', component.options)
    } else {
      api.reload('fe55dc24', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=fe55dc24&scoped=true&", function () {
      api.rerender('fe55dc24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/trial/commonly/index.vue"
export default component.exports